export default {
  en: {
    'pages.error-page.title': 'This is embarrassing! Something went wrong.',
    'pages.error-page.content':
      'This error has been logged and our team will look into it. Please return to the dashboard to continue.',
    'pages.error-page.button': 'Go back',
  },
};
